import Cron from './Component';
import { HEADER } from './meta';

export { HEADER };
export default Cron;
